export default {
  "hub": {
    "card": {
      "trigger": { "MANUAL": "Manuel", "SCHEDULED": "Planifié", "CRON": "Cron", "EVENT": "Événement" },
      "run": "Exécuter maintenant",
      "runStarted": "Actualisation lancée pour {name}",
      "runFailed": "L'actualisation n'a pas pu être lancée",
      "lastUpdated": "Mis à jour",
      "openEditor": "Ouvrir dans l'éditeur",
      "more": "Plus d'actions"
    },
    "preview": {
      "title": "Aperçu du jeu de données",
      "description": "Description",
      "noDescription": "Aucune description pour l'instant. Ajoutez-en une dans le panneau Documentation de l'éditeur.",
      "columns": "Colonnes",
      "rows": "Lignes",
      "visualizations": "Visualisations",
      "latestVersion": "Dernière version",
      "totalSize": "Taille totale",
      "trigger": "Déclencheur",
      "started": "Début",
      "ended": "Fin",
      "lastRun": "Dernière exécution",
      "status": { "success": "Terminée", "warning": "Terminée avec avertissements", "failed": "Échec" }
    },
    "title": "Jeux de données",
    "foldersSubtitle": "Folders",
    "datasetsSubtitle": "Datasets",
    "folder_select_input_placeholder": "Please select",
    "shared_datasets": "Shared Datasets",
    "readOnly": "Lecture seule",
    "sharedFolderMetaOne": "Partagé · {count} jeu de données",
    "sharedFolderMetaOther": "Partagé · {count} jeux de données",
    "sharedFolderMetaLoading": "Partagé",
    "sharedFolderCalloutDismiss": "Fermer",
    "sharedFolderCalloutTitle": "Partagés avec cet espace de travail · Lecture seule",
    "sharedFolderCalloutBody": "Ces jeux de données sont gérés dans {workspace}. Vous pouvez les ouvrir et les explorer ici ; leurs modifications se font dans {workspace}.",
    "shared_by": "Shared by",
    "shared_all": "Shared Datasets"
  }
};
